// extracted by mini-css-extract-plugin
module.exports = {"map":"Map-module--map--utoEh","mapFooter":"Map-module--map-footer--1gJg7"};